import { render, staticRenderFns } from "./CopyExercise.vue?vue&type=template&id=2b4a064a&scoped=true&"
import script from "./CopyExercise.vue?vue&type=script&lang=ts&"
export * from "./CopyExercise.vue?vue&type=script&lang=ts&"
import style0 from "./CopyExercise.vue?vue&type=style&index=0&id=2b4a064a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4a064a",
  null
  
)

export default component.exports